import { FC } from 'react'
import styled, { css } from 'styled-components'
import { ArrowRight } from 'svgIcons'

interface IFLeftItemProps {
  label: string
  onClick: () => void
  isActive?: boolean
  className?: string
}

const LeftItem: FC<IFLeftItemProps> = ({
  label,
  onClick,
  isActive = false,
  className,
}) => {
  return (
    <StyledWrapper
      className={className}
      data-is-active={isActive}
      onClick={onClick}
    >
      <div className="left-label">{label}</div>
      <ArrowRight className="arrow-right" />
    </StyledWrapper>
  )
}

export default LeftItem

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    display: inline-flex;
    cursor: pointer;
    justify-content: space-between;
    width: 100%;
    padding: 11px 10px;
    font-size: 13px;
    font-weight: normal;
    color: ${theme.color.hint_1};
    background-color: ${theme.background.bg_3};

    .left-label {
      padding-left: 10px;
      color: ${theme.color.text_1};
    }

    .arrow-right {
      width: 16px;
      height: 16px;
      padding: 2px;
    }
  `}
`
